import moment from "moment-timezone";
import {
    celciusToFarenheit,
    farenheitToCelsius
} from "@/services/unitsConversion.js";
import { VDatePickerDateTable } from "vuetify/lib";
import store from "@/store";


export default {
    methods: {

        getMetricStyle(t) {
            const vm = this;
            let packet = "";
            let m_t = moment(t);
            let timeDiff = moment().diff(m_t, "minutes");

            /*
            if (timeDiff > 24) {
              packet = {
                "background-color": "#ff4d4d",
                url: "/img/icons/clock_stop.png",
                message:
                  "No data received in more than 25 minutes. Last update was " +
                  vm.formatDate(t)
              };
            } else if (timeDiff > 14) {
              packet = {
                "background-color": "#ff8533",
                url: "/img/icons/clock_pause.png",
                message:
                  "No data received in more than 15 minutes. Last update was at " +
                  vm.formatDate(t)
              };
            }*/

            // return packet;

            return timeDiff >= 16;
        },

        calculateDewpoint(temperature, isCelsius, humi, isReturnTypeCelsius) {


            let temp = null;

            if (isCelsius) {
                temp = temperature;
            } else {
                temp = (temperature - 32) / 1.8;
            }


            let ans = (temp - (14.55 + 0.114 * temp) * (1 - (0.01 * humi)) - Math.pow(((2.5 + 0.007 * temp) * (1 - (0.01 * humi))), 3) - (15.9 + 0.117 * temp) * Math.pow((1 - (0.01 * humi)), 14));

            if (isReturnTypeCelsius) {
                return ans;           // returns dew Point in Celsius
            } else {

                let value = ans * (9.0 / 5.0);
                return value + 32.0;
            }
        },



        timeDiff(t) {
            if (t && moment(t).isValid()) {
                return moment(t).fromNow();
            } else {
                return "-";
            }
        },

        lateTimeDiff(item) {
          return Math.floor(item.lateIrrigationInMinutes) + ' mins late'
        },

        // vpd calculation -- see https://pulsegrow.com/blogs/learn/vpd
        calcVpd(tempC, humidity, vpdAdjustment) {

            if (!vpdAdjustment) {
                vpdAdjustment = 0;
            }

            let preferences = this.getUser.preferences.find(
                el => el.preference === "units"
            );
            if (preferences && preferences.setting === "imperial") {
                // vpdAdjustment expressed in F -- convert to C : 1C = 1.8F
                vpdAdjustment = vpdAdjustment / 1.8;
            }

            // humidity expressed in decimals, e.g. .5 is 50% RH
            let aSvp = (610.78 * Math.exp(tempC / (tempC + 238.3) * 17.2694) / 1000); // in kPa
            if (vpdAdjustment === 0) {
                return Math.round((aSvp * (1 - humidity)) * 100) / 100;
            } else {
                tempC += vpdAdjustment;
                let lSvp = (610.78 * Math.exp(tempC / (tempC + 238.3) * 17.2694) / 1000); // in kPa

                return (lSvp - (aSvp * humidity)).toFixed(2);
            }
        },

        calculateTemperatureDisplay(tempInCelcius) {

            let preferences = this.getUser.preferences.find(
                el => el.preference == "units"
            );
            if (preferences && preferences.setting == "imperial") {
                return `${parseFloat(celciusToFarenheit(tempInCelcius)).toFixed(1)} F`;
            }
            return `${parseFloat(tempInCelcius).toFixed(1)} C`;
        },

        calculateTemperatureDisplay2(tempInCelcius, isMetric) {
            if (isMetric) {
                return `${parseFloat(tempInCelcius).toFixed(1)} C`;
            } else {
                return `${parseFloat(celciusToFarenheit(tempInCelcius)).toFixed(1)} F`;
            }
        },

        calcDewpoint(temp, hum) {
            let dp = temp - (100 - hum * 100) / 5;
            dp = this.calculateTemperatureDisplay(dp);

            return dp;
        },

        createDisplayRecord(device, type) {

            const vm = this;

            let preferences = this.getUser.preferences.find(
                el => el.preference == "units"
            );

            let isMetric = true;
            if (preferences && preferences.setting == "imperial") {
                isMetric = false;
            }


            let platformGroupName = device.platformGroupName || device.controller;
            let pgSplitName = platformGroupName.split('-');
            if (pgSplitName.length == 3) {
                platformGroupName = pgSplitName[1] + '-' + pgSplitName[2];
            }
            let data = {
                facility_id: device.facility_id,
                dashboardDisplayType_id: device.dashboardDisplayType_id ? device.dashboardDisplayType_id : null,
                hardware_item_id: device.hardware_item_id,
                logLevel: device.logLevel,
                daysInFlower: device.daysInFlower,
                platformGroupName: platformGroupName,
                platformGroupNameFull: device.platformGroupName || device.controller,
                platformGroupType: device.platformGroupType,
                isRcu: device.RCUState ? true : false,
                exceptionCount: device.exceptionCount,
                exceptionMessage: device.exceptionMessage,
                lightIntensityAverage: Math.round(device.lightIntensityAverage * 100),
                state: device.deployed ? device.status : "NOT DEPLOYED",
                co2: device.co2,
                humidity: device.humidity,
                temperature: device.temperature,
                dewpoint: Math.round(this.calculateDewpoint(device.temperature, true, device.humidity * 100, isMetric) * 100) / 100 + (isMetric ? ' C' : ' F'),
                temperatureFormatted: this.calculateTemperatureDisplay2(device.temperature, isMetric),
                lastIrrigated: device.lastIrrigated,
                lastIrrigatedFormatted: vm.timeDiff(device.lastIrrigated),
                area: device.areaname,
                platformGroup_id: device.platformGroup_id,
                id: device.cortexVfuDevice_id || device.vfuDevice_id || device.pguDevice_id || device.lguDevice_id || device.rcuDevice_id,
                controller_id: device.controller_id,
                selected: false,
                co2ValveState: device.co2ValveState || "",
                lightState: device.lightState || "",
                curtainState: device.curtainState || "",
                irrigationState: device.irrigationState || "",
                vfuHumidifierState: device.vfuHumidifierState || "",
                vfuDehumidifierState: device.vfuDehumidifierState || "",
                vfu2StageDehumidifierState: device.vfu2StageDehumidifierState || "",
                ipAddress: device.ipAddress,
                softwareVersion: device.softwareVersion,
                firmwareVersion: device.firmwareVersion,
                lastCo2Update: device.lastCo2Update,
                lastCommandFetch: device.lastCommandFetch,
                lastHumidityUpdate: device.lastHumidityUpdate,
                lastTempUpdate: device.lastTempUpdate,
                uptime: vm.timeDiff(device.registered),
                loginTime: device.registered,
                ECUState: device.ECUState || "",
                BardState: device.BardState || "",
                heaterstripState: device.heaterstripState ? (device.heaterstripState === "HIGH" ? "ON" : "OFF") : "",
                warnMessage: device.warnMessage || '',
                mode: device.mode,
                type: type,
                lifecyclesRaw: device.lifecycles,
                formattedLoginTime: vm.formatDate(device.loginTime),
                formattedLastCommandFetch: vm.timeDiff(device.lastCommandFetch),
                currentState: "",
                ticketCount: device.ticketCount,
                deployed: device.deployed,
                disabled: device.isDisabled,
                tempLow: false,
                tempHigh: false,
                humidityLow: false,
                humidityHigh: false,
                co2Low: false,
                co2High: false,
                status: "",
                hasLifecycles: device.lifecycles ? true : false,
                isTesting: device.isTesting,
                pestDetected: device.pestDetected ? true : false,
                co2Enabled: !!(device.co2Enabled && (device.co2Enabled === 1 || device.co2Enabled.toUpperCase() === "TRUE")),
                facilityCo2Enabled: !!(device.facilityCo2Enabled && (device.facilityCo2Enabled === 1 || device.facilityCo2Enabled.toUpperCase() === "TRUE")),
                dewpoint: vm.calcDewpoint(device.temperature, device.humidity),
                strainName: device.lifecycles && device.lifecycles.length > 0 ? device.lifecycles[0].strainName : "<none>",

                xFertility: device.xFertility,
                xLux: device.xLux,
                xMoisture: device.xMoisture,
                xTemp: !isNaN(parseFloat(device.xTemp)) ? this.calculateTemperatureDisplay2(device.xTemp, isMetric) : "",

                isDnD: device.isDnD,
                dndExpiration: device.dndExpiration,
                dndUserName: device.dndUserFirstName + ' ' + device.dndUserLastName,
                dndComment : device.dndComment,

                infoIconColor: 'primary',
                title: ''
            };

            if (device.lifecycles) {
                for (let i = 0; i < device.lifecycles.length; i++) {
                    if (typeof device.lifecycles[i].currentPhase == 'object') {
                        let minutes = moment.utc().diff(moment.utc(device.lifecycles[i].currentPhase.starttime), 'minutes')
                        device.lifecycles[i].daysInPhase = Math.ceil(minutes / 60 / 24);
                        let sPhase = device.lifecycles[i].currentPhase.scheduledEnd;
                        let totalMinutes = moment.utc(sPhase).diff(moment.utc(device.lifecycles[i].currentPhase.scheduledStart), 'minutes')
                        device.lifecycles[i].totalDaysInPhase = Math.ceil(totalMinutes / 60 / 24);
                    } else {
                        console.error("currentPhase not found for ", device);
                    }
                }
            }

            if (device.isDisabled) {
                device.state = "DISABLED";
            }

            if (device.platformGroupType == "VFU") {
                data.currentState = device.CortexVfuState || device.VFUState;
            }

            if (device.RCUState) {
                data.currentState = device.RCUState;
            }

            if (device.lightState == "on") {
                data.lightStateTooltip = "Lights On";
            } else {
                data.lightStateTooltip = "Lights Off";
            }

            if (device.modalInfo) {
                data.lastUpdated = new Date(device.modalInfo["Last Update"]);
            } else {
                data.lastUpdated = null;
            }

            // lifecycle-related tooltips
            if (device.lifecycles && device.lifecycles.length > 0) {
                data.lifecycles = true;
                data.lifecyclesTooltip =
                    device.lifecycles[0].growplanName +
                    " (" +
                    device.lifecycles[0].lifecycle_id +
                    ")";
                " - " + device.lifecycles[0].strainName;


                if (
                    device.lifecycles[0].currentPhase &&
                    typeof device.lifecycles[0].currentPhase.photoperiod == "number"
                ) {
                    data.lightStateTooltip =
                        "Photoperiod : " +
                        device.lifecycles[0].currentPhase.photoperiod +
                        " hours, starting at " +
                        device.lifecycles[0].currentPhase.photoperiodStartTime +
                        " local time";
                }
            } else {
                data.lifecycles = false;
            }

            if (device.temperature && device.humidity) {

                data.vpd = this.calcVpd(device.temperature, device.humidity);

            } else {
                data.vpd = null;
            }

            // is offline?
            let currentTime = moment();
            let dur = moment.duration(currentTime.diff(moment(device.lastCommandFetch))).asMinutes();

            if (dur && dur >= 17 && !device.isTesting) {
                data.state = 'OFFLINE';
                data.uptime = "-";
            }

            return this.onVfuDataChange(data);
        },

        onVfuDataChange(data) {

            const env = process.env;

            let isDemo = false;
            if (env.VUE_APP_env === "dev") {
                isDemo = true;
            }


            if (data.lifecycles) {
                let lightsOn = {};
                let lightsOff = {};
                for (let i = 0; i < data.lifecyclesRaw.length; i++) {
                    if (data.lifecyclesRaw[i].currentPhase) {
                        let envs = data.lifecyclesRaw[i].currentPhase.environments;
                        for (let j = 0; j < envs.length; j++) {
                            if (envs[j].lightState == "Lights On") {
                                lightsOn = envs[j];
                            } else {
                                lightsOff = envs[j];
                            }
                        }
                    }
                }

                if (typeof data.lifecyclesRaw[0].currentPhase == "object") {
                    let photoPeriod = data.lifecyclesRaw[0].currentPhase.photoperiod;

                    if (photoPeriod == 24) {
                        data = this.validateEnvironment(data, lightsOn);
                    } else {
                        if (data.currentState == "LIGHT") {
                            data = this.validateEnvironment(data, lightsOn);
                        } else if (data.currentState == "DARK") {
                            data = this.validateEnvironment(data, lightsOff);
                        } else {
                            let startTime =
                                moment().format("DD") +
                                " " +
                                data.lifecyclesRaw[0].currentPhase.photoperiodStartTime;

                            let sTime = moment.utc(startTime, "DD HH:mm");

                            let eTime = sTime.clone().add(photoPeriod, "hours");

                            if (moment.utc().isBetween(sTime, eTime)) {
                                data = this.validateEnvironment(data, lightsOn);
                            } else {
                                data = this.validateEnvironment(data, lightsOff);
                            }
                        }
                    }
                }
            }

            // set icon
            data.title = 'Click to inspect';
            if (data.logLevel == 'DEBUG') {
                data.infoIcon = 'bug_report';
            } else if (data.isDnD && moment.utc(data.dndExpiration).isAfter(moment.utc())) {
                data.title = 'DO NOT DISTURB UNTIL ' + moment.utc(data.dndExpiration).local().format('YYYY-MM-DD H:mm a') + '\n' + data.dndComment + ' Contact ' + data.dndUserName + '.';
                data.infoIcon = 'do_not_disturb_on_total_silence';
            } else {
                data.infoIcon = 'info';
            }

            // set icon color

            if (data.state == 'OFFLINE' && !data.disabled && !data.isTesting && !isDemo) {
                data.infoIconColor = 'error';
            } else if ((data.disabled && !data.isTesting) || (data.state == 'UNDEPLOYED' && !data.isTesting)) {
                data.infoIconColor = 'black';
            } else if ((data.state == 'WARN' || data.lastTempReadingTime > 20) && !data.isTesting) {
                data.infoIconColor = 'warning';
            }


            return data;
        },

        validateEnvironment(device, environment) {
            let deviceStatus = [];
            if (device.temperature && environment && environment.temp) {
                device.tempLow = false;
                device.tempHigh = false;
                if (Math.round(device.temperature * 100) / 100 < environment.temp.min) {
                    device.tempLow = true;
                    deviceStatus.push("Temperature Low");
                } else if (device.temperature > environment.temp.max + 0.5) {
                    deviceStatus.push("Temperature High");
                    device.tempHigh = true;
                }
            }
            if (device.humidity && environment && environment.humidity) {
                device.humidityHigh = false;
                device.humidityLow = false;
                if (device.humidity * 100 < environment.humidity.min) {
                    deviceStatus.push("Humidity Low");
                    device.humidityLow = true;
                } else if (device.humidity * 100 > environment.humidity.max + 0.5) {
                    deviceStatus.push("Humidity High");
                    device.humidityHigh = true;
                }
            }

            if (
                this.facility.co2Enabled &&
                device.co2 &&
                environment &&
                environment.co2
            ) {
                device.co2Low = false;
                device.co2High = false;
                if (device.co2 < environment.co2.min) {
                    deviceStatus.push("CO2 Low");
                    device.co2Low = true;
                    device.co2High = false;
                } else if (device.co2 > environment.co2.max) {
                    // ignore high co2 if lights off, unless CO2 is super-high in dark
                    if (environment.lightState != 'Lights Off' || (environment.lightState === 'Lights Off' && device.co2 > 2000)) {
                        deviceStatus.push("CO2 High");
                        device.co2High = true;
                        device.co2Low = false;
                    }
                }
            }

            if (device.state != "OFFLINE") {
                if (deviceStatus.length > 0) {
                    device.warnMessage = deviceStatus.join(",");
                    device.state = "WARN";
                } else {
                    device.state = "HEALTHY";
                    device.warnMessage = "";
                }
            }

            // check last irrigated
            device.lateIrrigation = false;
            if (device.lastIrrigated) {
                if (environment.irrigation) {
                    let freq = environment.irrigation.frequency;
                    let irrigationRequired = environment.irrigation.duration !== 0 && device.lifecyclesRaw && device.lifecyclesRaw.length > 0 && !device.lifecyclesRaw[0].currentPhase.noIrrigation;
                    let currentTime = moment().utc();
                    let irrigationStartTime = moment.utc(environment.irrigation.startTime, "HHmm");
                    let irrigationEndTime = moment.utc(environment.irrigation.finishTime, "HHmm");
                    if (environment.irrigation.startTime === environment.irrigation.finishTime && currentTime.isBefore(irrigationStartTime)) {
                      irrigationStartTime.subtract(1, "days");
                    }
                    if (
                      irrigationEndTime.isBefore(irrigationStartTime) ||
                      (environment.irrigation.startTime === environment.irrigation.finishTime && currentTime.isAfter(irrigationStartTime))
                    ) {
                      irrigationEndTime.add(1, "days");
                    }
                    let lastValidIrrigation = moment.utc(device.lastIrrigated)
                    if (lastValidIrrigation.isBefore(irrigationStartTime)) {
                      lastValidIrrigation = irrigationStartTime
                    }
                    let duration = moment.duration(
                      currentTime.diff(moment.utc(lastValidIrrigation))
                    );
                    if (
                        duration.asMinutes() > freq + 10 &&
                        irrigationRequired &&
                        currentTime.isAfter(irrigationStartTime) &&
                        currentTime.isBefore(irrigationEndTime)
                    ) {
                        device.lateIrrigation = true;
                        device.lateIrrigationInMinutes = duration.asMinutes() - freq;
                        if (device.state != "OFFLINE") device.state = "WARN";
                    }
                } else {

                    device.lateIrrigation = true;
                    if (device.state != "OFFLINE") device.state = "WARN";
                }
            }

            return device;
        },

    }
};
